module.exports = __webpack_public_path__ + "img/20191209165326858.864ed8dd.jpg";